// extracted by mini-css-extract-plugin
module.exports = {"Button":"button_Button__2ZN_V","ButtonWrapper":"button_ButtonWrapper__uWpTG"};